var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubPageTemplate',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("NP後払い上限金額")]},proxy:true},{key:"content",fn:function(){return [_c('MaxOrderAmountForDeferredPaymentEditor',{staticClass:"mt-4"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }